// extracted by mini-css-extract-plugin
export const root = "pages-module--root--3GEOn";
export const bolder = "pages-module--bolder--1zRhZ";